document.addEventListener('alpine:init', () => {
  Alpine.data('questionnaire2025', (state = {}) => ({
    step: 1, // current step
    busy: false, // busy
    currentDogIndex: -1, // dog we are currently editing
    minWeight: 8000, // min cart weight
    recipeFilter: 'all', // current recipe filter
    extrasFilter: 'all', // current extras filter
    showSubscriptionDatePicker: false, // are we showing the subscription date picker
    showSubscriptionSchedulePicker: false, // are we showing the subscription schedule picker
    scheduleChanged: false, // has the schedule changed
    breeds: [], // Breeds
    breedsReady: false,
    choicesTimeout: false,
    modalProduct: false,
    modalProductType: false,
    menuChangedModal: false,
    dogWeightModal: false,
    scheduleChangedModal: false,
    hasTreats: false,
    datepicker: false, // schedule-start-date
    blockedDates: [],
    // After clicking back
    restored() {
      //
      this.breadcrumb('returning to questionnaire after clicking back');
      //
      this.busy = false;
      //
      document.body.classList.remove('rebuy-modal-visible', 'rebuy-cart-visible');
    },
    //
    deliverySchedule: {
      0: [1,2], // Mon - Tue/Wed
      1: [1,2], // Tue - Wed/Thu
      2: [1,2], // Wed - Thu/Fri
      3: [1,4], // Thu - Fri/Tue
      4: [3,3], // Fri - Tue/Tue
      5: [2,2], // Sat - Tue/Tue
      6: [2,2], // Sun - Wed/Wed
    },
    // Default dog configuration.
    defaultDog: {
      name: '',
      breed: '',
      unknown: false,
      gender: 'M',
      neutered: false,
      years: 0,
      months: 0,
      weight: '',
      active: '',
      bodyShape: '',
      hasAllergies: 0,
      allergies: [],
      healthConditions: false,
      selectedHealthConditions: [],
      currentFood: [],
      otherFoodBrand: '',
      otherFood: '',
      recipeHash: false,
      recipes: [],
      treat: '',
      extras: {},
      rdi: -1,
      complete: false,
      menu: [],
      menuWeight: 0,
      errors: {}
    },
    // The default data.
    data: {
      name: '',
      email: '',
      optin: false,
      schedule: '',
      selectedFirstDate: false,
      scheduledDates: false,
      dogs: []
    },
    weightModal: {
      dog: false,
      open: false
    },
    // Errors.
    errors: {},
    //
    scrollToFirstError() {
      const firstError = this.$el.closest('.questionnaire-2025').querySelector('.questionnaire-step:not([style]) .form-error:not([style])');
      if (firstError) {
        firstError.parentNode.scrollIntoView({ 
          behavior: 'instant' 
        });
      }
    },
    // Do something with the broadcasted data.
    broadcast(event, params) {
      console.log('Broadcast');
      console.log({ event, params });
    },
    //
    breadcrumb(message) {
      if (Sentry) {
        Sentry.addBreadcrumb({
          level: 'info',
          category: 'breadcrumb',
          message
        });
      }
    },
    error(error) {
      this.broadcast('error', error);
      if (Sentry) {
        Sentry.logger.error('Error!', error);
      }
    },
    //
    displayProductModal(product, type) {
      this.breadcrumb('display product modal: ' + JSON.stringify({product, type}));
      this.modalProduct = product;
      this.modalProductType = type;
    },
    //
    closeProductModal() {
      this.breadcrumb('close product modal');
      this.modalProduct = false;
      this.modalProductType = false;
    },
    //
    get currentPercentage() {
      //
      switch (this.step) {
        case 2:
          return 15;
        break;
        case 3:
          return 25;
        case 4:
          return 35;
        case 5:
          return 50;
        case 6:
          return 65;
        case 7:
          return 85;
        case 8:
          return 95;
      }
      //
      return ((100 / 8) * (this.step - 1)).toFixed(1).replace('.0', '');
    },
    //
    get sellingPlans() {
      return window.questionnaireSellingPlans;
    },
    //
    get filteredSellingPlans() {
      const weight = this.data.dogs.reduce((acc, d) => {
        acc += d.rdi;
        return acc;
      }, 0);
      return Object.keys(window.questionnaireSellingPlans).reduce((acc, key) => {
        let kWeight = weight * key;
        if (kWeight >= this.minWeight) {
          acc[key] = window.questionnaireSellingPlans[key];
        }
        return acc;
      }, {});
    },
    //
    get averageWeight() {
      if (this.currentDogIndex > -1) {
        let dog = this.currentDog,
          months = (dog.years * 12) + dog.months;
        
        if (dog.breed) {
          let breed = this.breeds.filter(f => f.name === dog.breed)[0],
            weight = Number.parseFloat(breed[`${(months <= 12 ? 'puppy' : 'adult')}_${(dog.gender === 'M' ? 'male' : 'female')}_avg_weight_kg`]);
          return `Average weight for ${(months <= 12 ? 'a 6 month old puppy' : 'an adult')} ${(dog.gender === 'M' ? 'male' : 'female')} ${dog.breed} is ${weight.toFixed(1).replace('.0', '')}kg`
        }
      }
      return '';
    },
    //
    get neuteredLabel() {
      if (this.currentDogIndex > -1) {
        let dog = this.currentDog;
        return this.neuteredLabels[dog.gender].replace(':name', dog.name);
      }
      return '';
    },
    //
    calculateDogPrice(idx) {
      if (!this.data.schedule) return {
        price: 0,
        oldPrice: 0,
        discount: 0,
        discountedPrice: 0
      };

      const dog = this.data.dogs[idx];

      let price = 0,
        oldPrice = 0,
        discount = 0;

      dog.menu.forEach((p) => {
        p.variants.forEach((v) => {
          if (v.quantity > 0 && p.id in window.questionnaireProducts && v.id in window.questionnaireProducts[p.id].options) {
            var sp = Object.values(window.questionnaireProducts[p.id].options[v.id].sellingPlans).filter(sp => sp.name === this.data.schedule)[0];
            price += (v.quantity * sp.price);
            oldPrice += (v.quantity * sp.oldPrice);
            discount += (v.quantity * sp.price) * this.discountAmount;
          }
        });
      });
      //
      Object.keys(dog.extras).forEach((p) => {
        //
        if (dog.extras[p] > 0 && p in window.questionnaireProducts) {
          var variantId = Object.keys(window.questionnaireProducts[p].options)[0],
            plan = Object.values(window.questionnaireProducts[p].options[variantId].sellingPlans).filter(sp => sp.name === this.data.schedule);

          if (plan.length) {
            price += (dog.extras[p] * plan[0].price);
            oldPrice += (dog.extras[p] * plan[0].oldPrice);
            discount += (dog.extras[p] * plan[0].price) * this.discountAmount;
          } else {
            price += (dog.extras[p] * window.questionnaireProducts[p].price);
            discount += (dog.extras[p] * window.questionnaireProducts[p].price) * this.discountAmount;
          }
        }
      });
      // We don't have as much precision as we'd like on the prices, so we add a penny to ensure we don't undercharge due to rounding issues.
      price += 0.01;
      //
      return {
        price,
        oldPrice,
        discount,
        discountedPrice: price - discount
      };
    },
    //
    addHealthCondition(e) {
      this.breadcrumb('click', 'add health condition');
      // 
      if (this.currentDogIndex > -1) {
        let dog = this.currentDog;
        if (!('selectedHealthConditions' in dog)) {
          dog.selectedHealthConditions = [];
        }
        if (e.target.value) {
          dog.selectedHealthConditions.push(e.target.value);
        }
        e.target.value = '';
      }
      return '';
    },
    // Calculate the scheduled dates.
    get scheduledDates() {
      //
      if (this.data.schedule && (!('scheduledDates' in this.data) || !this.data.scheduledDates)) {
        //
        let start = this.calculateDeliveryDate();
        //
        this.data.scheduledDates = new Array(this.discountPaymentLimit).fill({
          short: '',
          long: ''
        }).map((v, i) => {
          var v = {
            short: start.toISOString().split('T')[0],
            shortFormatted: String(start.getDate()).padStart(2, '0') + '/' + String(start.getMonth() + 1).padStart(2, '0') + '/' + start.getFullYear(),
            long: start.toLocaleString('en-GB', {
              dateStyle: 'long'
            }),
          };
          start.setDate(start.getDate() + this.daysInSelectedSchedule);
          start = this.calculateDeliveryDate(start);
          // @TODO: Do we need to handle weekends, bank holidays etc.
          return v;
        });
      }
      //
      return this.data.scheduledDates;
    },
    // Get the current dog.
    get currentDog() {
      if (this.currentDogIndex >= 0) {
        return this.data.dogs[this.currentDogIndex];
      }
      return this.defaultDog;
    },
    // The Recommended Daily Intake matrix.
    // Percentage based on age in months.
    // 5 Month Old - Just Right = 9%
    rdiMatrix: {
      4: {
        Slim: 8,
        'Just Right': 9,
        'Little Larger': 10
      }, 
      6: {
        Slim: 6,
        'Just Right': 7,
        'Little Larger': 8
      }, 
      8: {
        Slim: 4,
        'Just Right': 5,
        'Little Larger': 6
      }, 
      12: {
        Slim: 3,
        'Just Right': 3.5,
        'Little Larger': 4
      },
      999999999: {
        Slim: 3,
        'Just Right': 2.5,
        'Little Larger': 2
      }
    },
    //
    checkMenuChanged() {
      const dog = this.currentDog;
      if (!('ignoreMenuChanges' in dog) && 'menu' in dog && dog.menu.length && !this.arraysEquals(dog.recipes, dog.menu.map(p => p.id))) {
        this.menuChangedModal = true;
        this.breadcrumb('click', 'menu has changed');
      }
    },
    // Sort the recipes, putting the most relevant first based on breed, age and health conditions.
    sortRecipes(a, b) {
      if (this.currentDog) {
        // Dalmation?
        if (this.currentDog.breed === 'Dalmatian') {
          if (a.product_badges.includes('sensitive_recipe') && !b.product_badges.includes('sensitive_recipe')) {
            return -1;
          }
          if (!a.product_badges.includes('sensitive_recipe') && b.product_badges.includes('sensitive_recipe')) {
            return 1;
          }
        }
        // Puppy?
        if (this.currentDog.years < 1) {
          if (a.tags.includes('age_puppy') && !b.tags.includes('age_puppy')) {
            return -1;
          }
          if (!a.tags.includes('age_puppy') && b.tags.includes('age_puppy')) {
            return 1;
          }
        }
        // Senior?
        if (this.currentDog.years >= 10) {
          if (a.tags.includes('age_senior') && !b.tags.includes('age_senior')) {
            return -1;
          }
          if (!a.tags.includes('age_senior') && b.tags.includes('age_senior')) {
            return 1;
          }
        }
      }
      return a.sortOrder - b.sortOrder;
    },
    // Get the available products, filtered by dog, breed and age.
    get availableProducts() {
      if (this.currentDogIndex > -1) {
        let dog = this.currentDog;
        return Object.values(window.questionnaireProducts).sort((a, b) => a.sortOrder - b.sortOrder).filter(p => {
          // Exclude allergies.
          const found = p.tags.filter(v => dog.allergies.map(a => `Allergy_${a.toLowerCase()}`).includes(v));
          if (dog.hasAllergies && found.length) {
            return false;
          }
          return true;
        }).sort(this.sortRecipes.bind(this));
      }
      return [];
    },
    // Decrease Extra Quantity
    decreaseExtraQuantity(id) {
      let dog = this.currentDog;
      if (dog) {
        //
        if (id in dog.extras) {
          dog.extras[id] = Number.parseInt(dog.extras[id]) - 1;
        }
        if (isNaN(dog.extras[id]) || dog.extras[id] <= 0) {
          dog.extras[id] = 0;
        }
      }
    },
    // Increase Extra Quantity
    increaseExtraQuantity(id, set) {
      let dog = this.currentDog;
      if (dog) {
        //
        if (!(id in dog.extras)) {
          dog.extras[id] = 0;
        }
        dog.extras[id] = Number.parseInt(dog.extras[id]) + 1;
        if (isNaN(dog.extras[id])) {
          dog.extras[id] = 1;
        }
      }
    },
    //
    toggleDogMenu(dog) {
      if ('expanded' in dog && dog.expanded) {
        this.$el.closest('.questionnaire-2025').scrollIntoView({
          behavior: 'instant'
        });
      }
      dog.expanded = (!('expanded' in dog) || !dog.expanded ? true : false);
    },
    // Calculate Quantities
    calculateQuantities(dog, plan, entries) {
      const days = Number.parseInt(plan.replace(/[^0-9]+/gi, '')),
        goalWeight = (Number.parseInt(days) * dog.rdi),
        months = (dog.years * 12) + dog.months,
        tubWeight = (dog.rdi >= 250 ? 1000 : 500);

      let weight = 0,
        price = 0,
        oldPrice = 0,
        recipes = {};

      //
      const products = entries.map(p => window.questionnaireProducts[p]);
      //
      while (products.length && weight < goalWeight) {
        //
        products.forEach(p => {
          //
          if (weight >= goalWeight) return false;
          //
          let option = Object.values(p.options).filter(o => o.weight === tubWeight);
          //
          if (tubWeight === 1000 && option.length <= 0) {
            option = Object.values(p.options).filter(o => o.weight === 500);
          }
          //
          if (option.length <= 0) return;
          option = option.shift();
          //
          let currentPlan = Object.values(option.sellingPlans).filter(sp => sp.name === plan);
          if (currentPlan.length) {
            currentPlan = currentPlan.shift();
            if (!(p.id in recipes)) {
              recipes[p.id] = {
                id: p.id,
                name: p.name,
                variants: {}
              };
            }
            if (!(option.id in recipes[p.id].variants)) {
              recipes[p.id].variants[option.id] = {
                id: option.id,
                planId: currentPlan.planId,
                name: option.name,
                quantity: 0
              };
            }
            weight += option.weight;
            price += currentPlan.price;
            oldPrice += currentPlan.oldPrice;
            recipes[p.id].variants[option.id].quantity++;
          }
        });
      }
      // Flatten object to array.
      recipes = Object.values(recipes).reduce((acc, recipe) => {
        //
        recipe.variants = Object.values(recipe.variants);
        //
        acc.push(recipe);
        //
        return acc;
      }, []);
      
      // We don't have as much precision as we'd like on the prices, so we add a penny to ensure we don't undercharge due to rounding issues.
      price += 0.01;
      
      //
      let discount = price * this.discountAmount;
      price -= discount;
      //
      return {
        recipes,
        weight,
        goalWeight,
        price,
        oldPrice
      };
    },
    //
    arraysEquals(a, b) {
      if (a.length !== b.length) return false;
      //
      const sortedA = [...a].sort();
      const sortedB = [...b].sort();
      //
      return sortedA.every((value, index) => value === sortedB[index]);
    },
    //
    trimPlans(arr, index) {
      if (!Array.isArray(arr) || arr.length === 0) return [];

      // Start with a window around the index
      let start = index - 1;
      let end = index + 1;

      // Clamp to the array boundaries
      start = Math.max(start, 0);
      end = Math.min(end, arr.length - 1);

      // If we have fewer than 3 items, expand outward
      while (end - start + 1 < 3) {
          if (start > 0) {
              start--;
          } else if (end < arr.length - 1) {
              end++;
          } else {
              break; // No more items to expand to
          }
      }

      return arr.slice(start, end + 1);
    },
    //
    checkExistingMenus() {

      this.data.dogs.forEach((dog, idx) => {
        let hasError = false;  
        dog.menu.forEach((p) => {
          p.variants.forEach((v) => {
            if (v.quantity > 0 && (
              !(p.id in window.questionnaireProducts) ||
              !(v.id in window.questionnaireProducts[p.id].options) || 
              Object.values(window.questionnaireProducts[p.id]?.options[v.id].sellingPlans).filter(sp => sp.name === this.data.schedule).length === 0
            )) {
              hasError = true;
            }
          });
        });
        //
        if (hasError) {
          console.log('One or more products is no longer available, resetting menus');
          dog.recipeHash = '';
          dog.recipes = [];
          dog.menu = [];
          dog.complete = false;
          this.data.dogs[idx] = dog;
          this.data.schedule = '';
          this.data.scheduledDates = false;
        }
      });
    },
    // Recommend plans
    recommendPlans(dog, calculate) {
      //
      let tubWeight = (dog.rdi >= 250 ? 1000 : 500),
        selectedLength = (dog.breed === 'Dalmatian' || dog.years < 1 || dog.years >= 10 ? 1 : 8);
      //
      let products = (dog.recipes.length ? this.availableProducts.filter(f => dog.recipes.includes(f.id)) : this.availableProducts.filter(
        f => f.collections.includes(this.collectionHandles.menus) && Object.values(f.options).filter(
          o => ([tubWeight].includes(o.weight) || [500].includes(o.weight)) && Object.values(o.sellingPlans).map(sp => sp.name).every((v, i) => Object.values(this.sellingPlans).includes(v))
        ).length > 0
      ).slice(0, selectedLength).sort((a, b) => a.sortOrder - b.sortOrder));
      //
      let plans = Object.keys(this.sellingPlans).reduce((acc, k) => {
        //
        const goalWeight = (Number.parseInt(k) * dog.rdi);
        //
        if (goalWeight < this.minWeight) return acc;
        //
        acc.push({
          name: this.sellingPlans[k],
          days: k,
          goalWeight,
          weight: 0,
          price: 0,
          oldPrice: 0,
          recipes: {}
        });
        return acc;
      }, []);
      //
      while (true) {
        let pending = plans.filter(plan => plan.weight < plan.goalWeight);
        if (pending.length <= 0) break;
        let plan = pending.shift();
        if (plan) {
          let result = this.calculateQuantities(dog, plan.name, products.map(p => p.id));
          if (Object.keys(result.recipes).length === 0) {
            break;
          }
          plan.recipes = result.recipes;
          plan.weight = result.weight;
          plan.price = result.price;
          plan.oldPrice = result.oldPrice;
        }
      }
      //
      if (!('ignoreMenuChanges' in dog) && 'menu' in dog && dog.menu.length && this.data.schedule && plans.filter(f => f.name === this.data.schedule).length) {
        console.log('Replacing recommended menu with current menu');
        plans.filter(f => f.name === this.data.schedule)[0].recipes = dog.menu;
      }
      //
      let availablePlans = [...plans];
      //
      // if (plans.length > 3) {
      //   let middle = (this.data.schedule ? plans.findIndex((plan) => plan.name === this.data.schedule) : Math.floor((plans.length - 1) / 2));
      //   plans = this.trimPlans(plans, middle);
      // }
      if (availablePlans.length) {
        // Small Box
        plans = [availablePlans[0]];
        // Popular/Middle
        if (false && this.data.schedule) {
          plans.push(availablePlans[availablePlans.findIndex((plan) => plan.name === this.data.schedule)]);
        } else {
          plans.push(availablePlans[Math.floor((availablePlans.length - 1) / 2)]);
        }
        // Bulk Buy
        // plans.push(availablePlans[availablePlans.length - 1]);
        let tmp = Math.floor((availablePlans.length - 1) / 2) + 2;
        if (tmp > availablePlans.length - 1) {
          tmp = availablePlans.length - 1;
        }
        plans.push(availablePlans[tmp]);
      }
      // Filter duplicates
      plans = [...new Map(plans.map(plan => [plan.name, plan])).values()];
      //
      // if (this.data.schedule && plans.filter(f => f.name === this.data.schedule).length === 0) {
      //   plans = [];
      //   availablePlans.forEach((plan, i) => {
      //     if (plan.name === this.data.schedule) {
      //       plans = this.trimPlans(availablePlans, i);
      //       return false;
      //     }
      //   });
      // }
      //
      if (plans.length && !this.data.schedule) {
        this.data.schedule = plans[(plans.length > 1 ? 1 : 0)].name;
        this.data.dogs.forEach((d) => {
          if (d && this.data.schedule) {
            let result = this.calculateQuantities(d, this.data.schedule, d.recipes);
            d.recipes = result.recipes.map(p => p.id);
            d.goalWeight = result.goalWeight;
            d.menuWeight = result.weight;
            d.menu = result.recipes;
            delete d.ignoreMenuChanges;
          }
        });
        console.log('Setting initial plan');
      }
      //
      return plans;
    },
    // Calculate the recommended daily intake.
    calculateRDI(dog) {
      let multiplier = this.rdiMatrix[999999999][dog.bodyShape];
      dog.years = Number.parseInt(dog.years);
      dog.months = Number.parseInt(dog.months);
      if ((dog.years <= 0 && dog.months) || (dog.years == 1 && dog.months == 0)) {
        let months = (dog.years * 12) + dog.months;
        for (let maxMonths in this.rdiMatrix) {
          if (maxMonths > months) {
            break;
          }
          multiplier = this.rdiMatrix[maxMonths][dog.bodyShape];
        }
      }
      multiplier = (multiplier / 100);

      return Math.round((dog.weight * multiplier) * 1000);
    },
    //
    initChoices() {
      if (typeof Choices === 'undefined') {
        if (this.choicesTimeout) clearTimeout(this.choicesTimeout);
        this.choicesTimeout = setTimeout(this.initChoices.bind(this), 100);
        return;
      }
      if (this.breeds.length === 0) {
        this.fetchBreeds().then(this.initChoices.bind(this));
        return;
      }
      document.querySelectorAll('.questionnaire-2025 .dog-breed').forEach((select) => {
        if (!select.choices) {
          let val = select.value;
          select.choices = new Choices(select, {
            searchEnabled: true
          });
          select.addEventListener('change', (e) => {
            this.data.dogs[e.target.dataset.dogIdx].breed = select.choices.getValue(true);
          });
          if (val) {
            select.choices.setChoiceByValue(val);
          }
          this.choicesTimeout = false;
          this.breedsReady = true;
          select.choices.enable();
        }
      });
    },
    // Add a new dog.
    addDog() {
      this.data.dogs.push({...this.defaultDog});
      //
      this.broadcast('questionnaire_add_dog', {
        total_dogs: this.data.dogs.length
      });
      //
      if (this.choicesTimeout) clearTimeout(this.choicesTimeout);
      this.choicesTimeout = setTimeout(this.initChoices.bind(this), 100);
    },
    // Add a new dog.
    editDog(idx) {
      //
      this.broadcast('questionnaire_edit_dog', {
        name: this.data.dogs[idx].name
      });
      //
      this.currentDogIndex = idx;
      //
      this.step = 2;
      //
      this.$el.closest('.questionnaire-2025').scrollIntoView({
        behavior: 'instant'
      });
    },
    // Remove the selected dog.
    removeDog(index) {
      let dogs = [...this.data.dogs];
      delete dogs[index];
      this.data.dogs = [...dogs].filter(f => f);
      //
      this.broadcast('questionnaire_remove_dog', {
        total_dogs: this.data.dogs.length
      });
    },
    //
    get daysInSelectedSchedule() {
      if (this.data.schedule) {
        return Number.parseInt(this.data.schedule.replace(/[^0-9]+/gi, ''));
      }
      return 0;
    },
    //
    get calculateDailyPrice() {
      let dog = this.currentDog;
      if (dog && this.data.schedule) {
        if (this.step > 4 && dog.menu.length) {
          return (this.calculateScheduledPrice.price / this.daysInSelectedSchedule).toFixed(2).replace('.00', '');
        }
        let plans = this.recommendPlans(dog, true),
          plan = plans.filter(p => p.name === this.data.schedule)[0];
        if (plan) {
          return (plan.price / Number.parseInt(plan.days)).toFixed(2);
        }
      }
      return 0;
    },
    //
    get calculateScheduledPrice() {
      let price = 0,
          oldPrice = 0,
          discount = 0;
      //
      this.data.dogs.forEach((dog, idx) => {
        if (this.step >= 8 || idx === this.currentDogIndex) {
          //
          let tmp = this.calculateDogPrice(idx);
          price += tmp.price;
          oldPrice += tmp.oldPrice;
          discount += tmp.discount;
        }
      });
      //
      price -= discount;
      //
      return {
        price: price.toFixed(2),
        oldPrice: oldPrice.toFixed(2)
      };
    },
    //
    checkDogWeight() {
      let dog = this.currentDog;
      if (Number.parseInt(this.minDogWeight) && dog && Number.parseInt(dog.weight) < Number.parseInt(this.minDogWeight)) {
        this.dogWeightModal = true;
        dog.recipeHash = '';
        dog.recipes = [];
        dog.menu = [];
        dog.complete = false;
        this.data.schedule = '';
        this.data.scheduledDates = false;
        setTimeout(this.scrollToFirstError.bind(this), 50); 
      }
    },
    // Validate current step.
    validateStep() {
      let hasErrors = false;
      switch (this.step) {
        case 1:
          //
          this.data.dogs = [...this.data.dogs].map(d => {
            d.errors = {};
            if (d.name.length <= 0) {
              d.errors.name = 'Please enter the name of the dog';
            }
            if (!d.unknown && d.breed.length <= 0) {
              d.errors.breed = 'Please select the dogs breed, or tick I don\'t know.';
            }
            if (!hasErrors && Object.keys(d.errors).length) {
              hasErrors = true;
            } else {
              const hash = d.years + ':' + d.breed + ':' + (d.hasAllergies ? 1 : 0) + '-' + d.allergies.sort().join('-');
              if (!('recipeHash' in d) || d.recipeHash !== hash || d) {
                d.recipeHash = hash;
                d.recipes = [];
                d.menu = [];
                d.complete = false;
                this.data.schedule = '';
                this.data.scheduledDates = false;
                console.log('Allergies changed, resetting menus etc.');
              }
            }
            return d;
          });
          //
          if (!hasErrors) {
            // 
            this.currentDogIndex = -1;
            this.step = 7;
            this.data.dogs.forEach((d, i) => {
              if (this.currentDogIndex <= -1 && !d.complete) {
                this.currentDogIndex = i;
                this.step = 1;
              }
            });
          }
        break;
        case 2:
          var dog = this.currentDog;
          dog.errors = {};
          this.errors = {};

          if (!('gender' in dog) || ['M', 'F'].indexOf(dog.gender) === -1) dog.errors.gender = 'Please tell us ' + dog.name + '\'s gender.';
          if (!('neutered' in dog) || [0, 1, '0', '1', true, false].indexOf(dog.neutered) === -1) dog.errors.neutered = 'Please tell us if ' + dog.name + ' has been neutered.';
          if (dog.years <= 0 && dog.months <= 0) dog.errors.dob = 'Please tell us how old ' + dog.name + ' is.';
          if (Number.parseInt(dog.weight) < Number.parseInt(this.minDogWeight)) {
            dog.errors.weight = 'Please tell us how much ' + dog.name + ' weighs.';
            this.dogWeightModal = true;
            dog.recipeHash = '';
            dog.recipes = [];
            dog.menu = [];
            dog.complete = false;
            this.data.schedule = '';
            this.data.scheduledDates = false;
          }
          if (!('bodyShape' in dog) || Object.keys(this.bodyShapes).indexOf(dog.bodyShape) === -1) dog.errors.bodyShape = 'Please tell us ' + dog.name + '\'s body shape.';
          if (!('active' in dog) || Object.keys(this.activities).indexOf(dog.active) === -1) dog.errors.active = 'Please tell us how active ' + dog.name + ' is.';
          if (!('hasAllergies' in dog) || [0, 1, '0', '1', true, false, 'true', 'false'].indexOf(dog.hasAllergies) === -1) dog.errors.hasAllergies = 'Please tell us if ' + dog.name + ' has any known allergies.';
          if ([1, '1', true].indexOf(dog.hasAllergies) > -1 && (!('allergies' in dog) || dog.allergies.length == 0)) dog.errors.allergies = 'Please select what ' + dog.name + ' is allergic to.';
          if (!('healthConditions' in dog) || [0, 1, '0', '1', true, false, 'true', 'false'].indexOf(dog.healthConditions) === -1) dog.errors.healthConditions = 'Please tell us if ' + dog.name + ' has any health conditions.';
          if ([1, '1', true].indexOf(dog.healthConditions) > -1 && (!('selectedHealthConditions' in dog) || dog.selectedHealthConditions.length == 0)) dog.errors.selectedHealthConditions = 'Please select what health conditions ' + dog.name + ' has.';
          if (!('currentFood' in dog) || dog.currentFood.length == 0) dog.errors.currentFood = 'Please tell us what ' + dog.name + ' currently has for dinner.';
          if ('currentFood' in dog && dog.currentFood.includes('Raw Food (Another Brand)') && dog.otherFoodBrand.length <= 0) dog.errors.otherFoodBrand = 'Please tell us what brand of Raw Food ' + dog.name + ' eats.';
          if ('currentFood' in dog && dog.currentFood.includes('Other') && dog.otherFood.length <= 0) dog.errors.otherFood = 'Please tell us other food ' + dog.name + ' eats.';

          if (!('name' in this.data) || this.data.name == '') this.errors.name = 'Please enter your name.';
          if (!('email' in this.data) || this.data.email == '') this.errors.email = 'Please enter your email address.';
          if ('email' in this.data && this.data.email.length > 0 && /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(this.data.email) == false) this.errors.email = 'Please enter a valid email address.';

          hasErrors = Object.keys(dog.errors).length > 0 || Object.keys(this.errors).length > 0;

          dog.rdi = 0;
          if (!hasErrors) {
            dog.rdi = this.calculateRDI(dog);

            const hash = dog.years + ':' + dog.breed + ':' + (dog.hasAllergies ? 1 : 0) + '-' + dog.allergies.sort().join('-');
            if (!('recipeHash' in dog) || dog.recipeHash !== hash || Number.parseInt(dog.weight) < Number.parseInt(this.minDogWeight)) {
              dog.recipeHash = hash;
              dog.recipes = [];
              dog.menu = [];
              dog.complete = false;
              this.data.schedule = '';
              this.data.scheduledDates = false;
              console.log('Allergies changed, resetting menus etc.');
            }

            if (Object.keys(dog.extras).length === 0) {
              dog.extras = Object.values(window.questionnaireProducts).reduce((acc, p) => {
                acc[p.id] = 0;
                return acc;
              }, {});
            }

            if (this.data.schedule && this.recommendPlans(this.currentDog).filter(f => f.name === this.data.schedule).length === 0) {
              console.log('Selected schedule is not available for current dog');
              this.data.schedule = '';
            }
          }

        break;

        case 3:

          var dog = this.currentDog;
          if (dog && this.data.schedule) {
            let plans = this.recommendPlans(dog, true);
            dog.recipes = plans.filter(f => f.name === this.data.schedule)[0].recipes.map(p => p.id);
            delete dog.ignoreMenuChanges;
          }

        break;

        case 4:

          var dog = this.currentDog;
          if (dog && this.data.schedule) {
            let result = this.calculateQuantities(dog, this.data.schedule, dog.recipes);
            dog.menu = result.recipes;
            dog.recipes = result.recipes.map(p => p.id);
            dog.goalWeight = result.goalWeight;
            dog.menuWeight = result.weight;
            delete dog.ignoreMenuChanges;
          }

        break;
      }

      //
      setTimeout(this.scrollToFirstError.bind(this), 50); 

      if (!hasErrors) {
        //
        this.broadcast('questionnaire_next_step', {
          stepFrom: this.step,
          stepTo: this.step + 1
        });
      }
      return !hasErrors;
    },
    //
    updateMenuWeight() {
      //
      this.data.dogs.forEach((dog) => {
        //
        if ('menu' in dog && dog.menu.length) {
          //
          var weight = 0;
          //
          dog.menu.forEach((p) => {
            p.variants.forEach((v) => {
              if (v.quantity > 0) {
                weight += (v.quantity * window.questionnaireProducts[p.id].options[v.id].weight);
              }
            });
          });
          //
          dog.menuWeight = weight;
          dog.goalWeight = this.daysInSelectedSchedule * dog.rdi;
        }
      })
    },
    //
    checkMenuWeight(idx) {
      const dog = this.data.dogs[idx];
      setTimeout(() => {
        if (!('ignoreMenuWeight' in dog) && dog.menuWeight < dog.goalWeight) {
          this.weightModal.dog = dog;
          this.weightModal.dogIdx = idx;
          this.weightModal.open = true;
          return;
        }
        dog.backupMenu = JSON.parse(JSON.stringify(dog.menu));
      }, 10);
    },
    //

    //
    revertMenuWeightChange(idx) {
      const dog = this.data.dogs[idx];
      dog.menu = JSON.parse(JSON.stringify(dog.backupMenu));
      this.weightModal.dog = false;
      this.weightModal.dogIdx = false;
      this.weightModal.open = false;
    },
    //
    keepMenuWeightChange(idx) {
      const dog = this.data.dogs[idx];
      delete dog.backupMenu;
      dog.ignoreMenuWeight = true;
      this.weightModal.dog = false;
      this.weightModal.dogIdx = false;
      this.weightModal.open = false;
    },
    // Handle next step.
    nextStep() {
      if (!this.datepicker) {
        const minDate = this.calculateDeliveryDate(new Date());
        //
        const maxDate = new Date();
        maxDate.setMonth(maxDate.getMonth() + 2);
        //
        const datePickerInput = document.querySelector('#schedule-start-date');
        //
        this.datepicker = new Datepicker(datePickerInput, {
          daysOfWeekDisabled: [0, 1, 6],
          daysOfWeekHighlighted: [2, 3, 4, 5],
          minDate,
          maxDate,
          datesDisabled: this.blockedDates,
          format: 'yyyy-mm-dd',
          orientation: 'top auto',
          container: '.questionnaire-delivery-schedule'
        });
        //
        datePickerInput.addEventListener('changeDate', (e) => {         
          //
          this.data.scheduledDates = false;
          //
          this.data.selectedFirstDate = e.target.value;
          //
          this.scheduledDates;

        });
      }
      let step = this.step;
      // Skip treats if we don't have any.
      if (step === 4 && !this.hasTreats) {
        step = 5;
      }
      // Carry out validation, if required.
      if (this.validateStep()) {
        const el = this.$el.closest('.questionnaire-2025');
        setTimeout(() => {
          el.closest('.questionnaire-2025').scrollIntoView({
            behavior: 'instant'
          });

          step++;
          
          // Was 7
          if (this.step === 7) {            
            this.currentDog.complete = true;
            this.currentDogIndex = -1;
            this.data.dogs.forEach((d, i) => {
              d.backupMenu = JSON.parse(JSON.stringify(d.menu));
              d.expanded = (this.data.dogs.length === 1);
              if (!this.hasTreats && d.treat) {
                delete d.treat;
              }
              delete d.ignoreMenuWeight;
              if (this.currentDogIndex <= -1 && !d.complete) {
                this.currentDogIndex = i;
                step = 2;
              }
            });
          }
          this.step = step;
        }, 50);
      }
    },
    // Handle previous step.
    prevStep() {
      if (this.step > 1) {
        let step = this.step;
        //
        if (this.step === 2 && this.currentDogIndex > 0) {
          this.currentDogIndex--;
          step = 7;
        } else if (this.step === 2 && this.currentDogIndex === 0) {
          this.currentDogIndex = -1;
        }

        // Skip treats if we don't have any.
        if (step == 6 && !this.hasTreats) {
          step = 5;
        }

        //
        step--;
        //
        if (this.step === 6 && this.currentDogIndex === -1) {
          this.currentDogIndex = this.data.dogs.length - 1;
        } else if (this.step === 6 && this.currentDogIndex > 0) {
          this.currentDogIndex--;
        }
        //
        this.step = step;
        //
        this.broadcast('questionnaire_prev_step', {
          stepFrom: this.step + 1,
          stepTo: this.step
        });
      }
    },
    toggleSelected() {
      if (this.modalProduct && this.modalProductType) {
        switch (this.modalProductType) {
          case 'recipe':
            if (this.currentDog.recipes.includes(this.modalProduct.id)) {
              this.currentDog.recipes = this.currentDog.recipes.filter(f => f != this.modalProduct.id);
            } else {
              this.currentDog.recipes.push(this.modalProduct.id); 
            }
          break;
          case 'treat':
            this.currentDog.treat = (this.currentDog.treat == this.modalProduct.id ? false : this.modalProduct.id);
          break;
          case 'extra':
            this.currentDog.extras[this.modalProduct.id]++;
          break;
        }
      } 
    },
    //
    get isSelected() {
      //
      if (!this.modalProduct || !this.modalProductType) return false;
      //
      let result = false;
      switch (this.modalProductType) {
        case 'recipe':
          result = this.currentDog.recipes.includes(this.modalProduct.id);
        break;
        case 'extra':
          result = this.modalProduct.id in this.currentDog.extras && this.currentDog.extras[this.modalProduct.id] > 0;
        break;
        case 'treat':
          result = this.currentDog.treat == this.modalProduct.id;
        break;
      }
      return result;
    },
    //
    async fetchBreeds(cursor) {
      let breedCacheCreated = localStorage.getItem('questionnaire-2025_breeds_cached_at') || 0,
        breedCacheTimeout = 3600,
        cachedBreeds = localStorage.getItem('questionnaire-2025_breeds');
        
      if (cachedBreeds && (Date.now() - breedCacheCreated < breedCacheTimeout)) {
        this.breeds = JSON.parse(cachedBreeds);
        if (this.choicesTimeout) clearTimeout(this.choicesTimeout);
        this.choicesTimeout = setTimeout(this.initChoices.bind(this), 100);
        return;
      }

      let body = await fetch('https://benyfit-natural.myshopify.com/api/2025-10/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': '72f10c158f8ac2337fffd5b0a06f2fb7'
        },
        body: JSON.stringify({
          query: `query ($cursor: String) {
  metaobjects(type: "dog_breed", first: 250, after: $cursor) {
    nodes {
        fields {
            key
            value
        }
    }
    pageInfo {
        hasNextPage
        endCursor
    }
  }
}`,
          variables: {
            cursor
          }
        })
      }).then(b => b.json());

      body.data.metaobjects.nodes.forEach((breed) => {
        this.breeds.push(breed.fields.reduce((acc, item) => {
          acc[item.key] = item.value;
          return acc;
        }, {}));
      });

      if (body.data.metaobjects.pageInfo.hasNextPage) {
        await this.fetchBreeds(body.data.metaobjects.pageInfo.endCursor);
      } else {
        // Filter out any duplicates.
        this.breeds = [...new Map(this.breeds.map(breed => [breed.name, breed])).values()];
        // Sort by sort order, then name.
        this.breeds.sort((a, b) => {
          return Number.parseInt(a.sort_order) - Number.parseInt(b.sort_order) || a.name.localeCompare(b.name);
        }); 
        if (this.choicesTimeout) clearTimeout(this.choicesTimeout);
        this.choicesTimeout = setTimeout(this.initChoices.bind(this), 100);
        // Cache breeds in local storage for next time.
        localStorage.setItem('questionnaire-2025_breeds', JSON.stringify(this.breeds));
        localStorage.setItem('questionnaire-2025_breeds_cached_at', Date.now());
      }
    },
    //
    async clearChangedDog($event) {
      //
      this.data.dogs = this.data.dogs.map((d) => {
        // If the dog has changed name, start afresh.
        if ('backupName' in d && d.backupName && d.backupName != d.name) {
          d = {
            ...this.defaultDog,
            name: d.name,
            breed: '',
            unknown: false
          };
        }
        return d;
      });
    },
    //
    calculateDeliveryDate(date = undefined) {
      //
      if (!date) {
        date = (this.data.selectedFirstDate ? new Date(this.data.selectedFirstDate) : new Date());
      }
      //
      let cutoff = new Date(),
        now = new Date(),
        dateStr = false,
        valid = true;

      cutoff.setHours(12, 30, 0, 0);

      // If the selected date is in the past, start from today.
      if (date < now) {
        date = now;
      }

      // Add the required number of days to the date, based on the delivery schedule.
      date.setDate(date.getDate() + this.deliverySchedule[date.getDay()][(now.getTime() <= cutoff.getTime() ? 0 : 1)]);

      // Loop forward until we have a valid date that is not blocked.
      while (true) {
        dateStr = date.toISOString().split('T')[0];

        valid = true;
        
        // Is it a blocked day of the week? (Sat, Sun, Mon)
        if (valid && [0, 1, 6].indexOf(date.getDay()) > -1) {
          valid = false;
        }
        
        // Is the date blocked?
        if (valid && this.blockedDates.includes(dateStr)) {
          valid = false;
        }

        if (valid) {
          break;
        }
        date.setDate(date.getDate() + 1);
      }

      return date;
    },
    //
    updateMenuQuantities() {
      this.scheduleChanged = false;
      this.scheduleChangedModal = false;
      delete this.data.scheduledDates;
      this.data.dogs.forEach((dog) => {
        let result = this.calculateQuantities(dog, this.data.schedule, dog.menu.map(p => p.id));
        dog.menu = result.recipes;
        dog.recipes = result.recipes.map(p => p.id);
        dog.goalWeight = result.goalWeight;
        dog.menuWeight = result.weight;
      });
    },
    //
    selectedScheduleChanged(plan) {
      //delete data.scheduledDates; scheduleChanged = true
      if (this.step === 8) {
        this.scheduleChangedModal = true;
      } else {
        this.scheduleChanged = (this.data.schedule && this.data.schedule != plan.name); 
        delete this.data.scheduledDates;
        this.data.dogs.forEach((d, idx) => {
          if (this.data.schedule && idx != this.data.currentDogIndex) {
            let result = this.calculateQuantities(d, this.data.schedule, d.recipes);
            d.recipes = result.recipes.map(p => p.id);
            d.goalWeight = result.goalWeight;
            d.menuWeight = result.weight;
            d.menu = result.recipes;
            delete d.ignoreMenuChanges;
            this.data.dogs[idx] = d;
          }
        });
      }
    },
    // Initialise the questionnaire.
    async init() {
      //
      this.$el.closest('.questionnaire-2025').scrollIntoView({
        behavior: 'instant'
      });
      //
      this.fetchBreeds();
      // Load previously stored data.
      if (localStorage.getItem('questionnaire-2025')) {
        let data = JSON.parse(localStorage.getItem('questionnaire-2025'));
        data.dogs = data.dogs.map(d => {
          d.backupName = d.name;
          return {...this.defaultDog, ...d, errors: {}};
        });
        this.data = {
          name: '', 
          email: '',
          optin: false, 
          schedule: '',
          ...data,
          scheduledDates: false,
          selectedFirstDate: false, 
        };
        //
        this.broadcast('questionnaire_resume', this.data);
      } else { 
        //
        this.broadcast('questionnaire_start');
      }

      // Start with at least one dog.
      if (this.data.dogs.length === 0) {
        this.addDog();
      }

      // Update local storage whever anything changes.
      this.$watch('data', value => {
        localStorage.setItem('questionnaire-2025', JSON.stringify(value));
        //
        this.updateMenuWeight();
        //
        this.broadcast('questionnaire_update', value);
      });
      //
      this.checkExistingMenus();
    },
    //
    get feedingGuideAllergies() {
      let d = this.data.dogs.reduce((acc, d) => {
        if (d.allergies.length) {
          d.allergies.forEach((a) => {
            if (this.allergens[a].feedingGuide.title && this.allergens[a].feedingGuide.text) {
              if (!(a in acc)) {
                acc[a] = {...this.allergens[a], dogs: []};
              }
              acc[a].dogs.push(d.name);
            }
          });
        }
        return acc;
      }, {});
      return d;
    },
    //
    get transitioningToRaw() {
      return this.data.dogs.filter((d) => {
        // Determine if the dog is transitioning to raw.
        // If we are already eating raw food, bail.
        if (d.currentFood.filter(f => f.toLowerCase().indexOf('raw') > -1).length === 1) return false;
        // If we do not have any raw food in our menu, bail.
        if (d.menu.filter(f => f.name.toLowerCase().indexOf('raw') > -1).length === 0) return false;
        // We are transitioning to raw.
        return true;
      });
    },
    //
    toggleSubscriptionDatePicker() {
      this.showSubscriptionDatePicker = !this.showSubscriptionDatePicker;
      if (this.showSubscriptionDatePicker) {
        setTimeout(() => {
          document.querySelector('#schedule-start-date').focus();
        }, 50);
      }
    },
    //
    async klaviyo(optin) {
    //Client ID: PmJ9iJ
    //List ID: MfbX7j
      try {
        const parts = this.data.name.split(' ');
        const properties = this.data.dogs.reduce((acc, dog, index) => {
          //                 
          const dob = new Date();
          dob.setFullYear(dob.getFullYear() - dog.years);
          dob.setMonth(dob.getMonth() - dog.months);

          //
          acc[`dogs.${index}.name`] = dog.name;
          acc[`dogs.${index}.birthday`] = dob.toLocaleString('en-GB', { month: 'long' }) + ' 1, ' + dob.getFullYear();
          acc[`dogs.${index}.breed`] = (dog.breed ?? 'Unknown');
          acc[`dogs.${index}.gender`] = dog.gender == 'M' ? 'boy' : 'girl';
          acc[`dogs.${index}.is_neutered`] = dog.neutered ? 'yes' : 'no';
          acc[`dogs.${index}.weight`] = dog.weight;
          acc[`dogs.${index}.body_shape`] = dog.bodyShape;
          acc[`dogs.${index}.active`] = dog.active;
          acc[`dogs.${index}.allergies`] = dog.allergies.length ? dog.allergies.join(', ').toLowerCase() : 'no allergies';
          acc[`dogs.${index}.health_conditions`] = dog.healthConditions ? dog.selectedHealthConditions.join(',').toLowerCase() : 'no health conditions';
          acc[`dogs.${index}.eats`] = dog.currentFood.join(', ').toLowerCase();

          //
          return acc;
        }, {
          'Accepts Marketing': optin,
          name: this.data.name
        });

        let body = JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              properties,
              metric: {
                data: {
                  type: 'metric',
                  attributes: {
                    name: 'Answered the questionnaire'
                  }
                }
              },
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: this.data.email,
                    first_name: parts.shift(),
                    last_name: parts.join(' '),
                    properties
                  }
                }
              }
            }
          }
        });

        this.breadcrumb('klaviyo profile: ' + JSON.stringify(body));

        await fetch('https://a.klaviyo.com/client/events?company_id=PmJ9iJ', {
          method: 'POST',
          headers: {
            accept: 'application/vnd.api+json',
            revision: '2025-10-15',
            'content-type': 'application/vnd.api+json'
          },
          body
        });

        if (optin) {
          body = JSON.stringify({
            data: {
              type: 'subscription',
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id: 'MfbX7j'
                  }
                }
              },
              attributes: {
                custom_source: 'Answered the questionnaire',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: this.data.email,
                      first_name: parts.shift(),
                      last_name: parts.join(' '),
                      properties,
                      subscriptions: {
                        email: {
                          marketing: {
                            consent: 'SUBSCRIBED'
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          });
          this.breadcrumb('klaviyo subscription: ' + JSON.stringify(body));
          await fetch('https://a.klaviyo.com/client/subscriptions?company_id=PmJ9iJ', {
            method: 'POST',
            headers: {
              accept: 'application/vnd.api+json',
              revision: '2025-10-15',
              'content-type': 'application/vnd.api+json'
            },
            body
          });
        }
      } catch (err) {
        this.error(err);
      }
    },
    async addToCart() {
      //
      if (this.busy) return;
      this.busy = true;
      //
      await this.klaviyo(this.data.optin);
      //
      let cart = {
        start_date: this.scheduledDates[0].short,
        next_charge_scheduled_at: this.scheduledDates[0].short,
        attributes: {
          'Delivery Date': this.scheduledDates[0].shortFormatted,
        },
        items: []
      };
      //
      this.data.dogs.forEach((dog) => {
        //
        if (dog.treat) {
          cart.attributes[`Treat (${dog.name.replace('\'', '\\\'')})`] = window.questionnaireProducts[dog.treat].name;
          cart.items.push({
            id: window.questionnaireProducts[dog.treat].variationId,
            pid: dog.treat,
            quantity: 1
          });
        }
        //
        dog.menu.forEach((p) => {
          p.variants.forEach((v) => {
            if (v.quantity > 0) {
              cart.items.push({
                id: v.id,
                pid: p.id,
                quantity: v.quantity,
                selling_plan: v.planId
              });
            }
          });
        });
        //
        if (dog.extras) {
          //
          Object.keys(dog.extras).forEach((p) => {
            //
            if (dog.extras[p] > 0 && p in window.questionnaireProducts) {
              //
              var variantId = Object.keys(window.questionnaireProducts[p].options)[0],
                planId = Object.values(window.questionnaireProducts[p].options[variantId].sellingPlans).filter(sp => sp.name === this.data.schedule)[0].planId;

              //
              cart.items.push({
                id: variantId,
                pid: p,
                quantity: dog.extras[p],
                selling_plan: planId
              });
            }
          })
        }
      });
      
      //
      this.broadcast('questionnaire_add_to_cart', {
        cart
      });

      //
      try {
        document.documentElement.classList.add('questionnaire-2025__hide');
        //
        this.breadcrumb('getting current subscirptions in cart');
        const currentCart = await (await fetch('/cart.js')).json();
        if (currentCart && currentCart.items.length) {
          //
          let updates = currentCart.items.reduce((acc, item) => {
            if (item?.selling_plan_allocation?.selling_plan?.id) {
              acc[item.key] = 0;
            }
            return acc;
          }, {});
          //
          this.breadcrumb('removing current subscriptions from cart');
          //
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              updates
            })
          });
        }
        //
        this.breadcrumb('Adding new subscription to cart');
        //
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(cart)
        }).then(b => b.json());
        // 
        window.location.href = '/checkout?discount=' + this.discountCode; 
      }
      catch (err) {
        //
        this.error(err);
        //
        this.broadcast('questionnaire_add_to_cart_error', {
          cart,
          error: err
        });
        return false;
      }
    },
    ...state
  }));
});